'use client';

import { useEffect, useState } from 'react';

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // The chat panel covers this corner when open — stay out of the way.
  useEffect(() => {
    const onChat = (e: Event) => setChatOpen((e as CustomEvent<{ open: boolean }>).detail.open);
    window.addEventListener('zain:state', onChat);
    return () => window.removeEventListener('zain:state', onChat);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!visible || chatOpen) return null;

  return (
    <button
      onClick={scrollUp}
      aria-label="Back to top"
      className="
        fixed bottom-[88px] inset-e-6 z-40
        w-10 h-10 rounded-full
        bg-(--surface) border border-(--border)
        text-(--muted) hover:text-primary-500 hover:border-primary-500
        shadow-md hover:shadow-lg
        flex items-center justify-center
        transition-all duration-180
        animate-scale-in
        cursor-pointer
      "
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
}

export default ScrollToTop;
